import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Apollo, Mutation } from 'apollo-angular';


export class CreateScoringCriteriaInput {
  remunerationId: number;
  scoreLevelId: number
  minValue: number;
  maxValue: number;
  points: number;
}


export type CreateScoringCriteriaMutationVariables = {
  input: {
    remunerationId: number;
    scoreLevelId: number;
    minValue: number;
    maxValue: number;
    points: number;
  };
};

export type CreateScoringCriteriaMutation = {
  createScoringCriteria: {
    id: string;
  };
};

export const CreateScoringCriteriaDocument = gql`
  mutation CreateScoringCriteria($input: CreateScoringCriteriaDto!) {
  createScoringCriteria(data: $input) {
    id
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateScoringCriteriaGQL extends Mutation<
  CreateScoringCriteriaMutation,
  CreateScoringCriteriaMutationVariables
> {
  document = CreateScoringCriteriaDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
